export const isInBrowser = typeof window === 'object' && typeof document === 'object'